module.exports = "<a href=\"<%=url%>\" title=\"Retour aux résultats de recherche (<%=total%>)\"></a>";
